import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { faFacebookSquare, faYoutube } from '@fortawesome/free-brands-svg-icons';
import { Organization } from 'src/app/classes/organization';
import { ApiService } from 'src/app/services/api.service';
import { SettingsService } from 'src/app/services/settings.service';

@Component({
  selector: 'app-press',
  templateUrl: './press.component.html',
  styleUrls: ['./press.component.scss']
})
export class PressComponent implements OnInit {
  environment = environment;
  locale = $localize.locale;
  organization = new Organization();
  defaultFacebookLink = environment.default_facebook_link;
  defaultXLink = environment.default_x_link;
  defaultYoutubeChannelLink = environment.default_youtube_channel_link;
  fa = {
    faFacebookSquare,
    faYoutube
  };
  platform_fee: any;
  organizations: Organization[] = [];
  stats: any;

  constructor(
    private apiService: ApiService,
    private settingsService: SettingsService
  ) { }

  ngOnInit() {

    this.apiService.organizations().subscribe(organizations => {
      this.organizations = organizations;
    });

    this.settingsService.getPlatformFee().subscribe(platform_fee => {
      this.platform_fee = platform_fee;
    });

    this.settingsService.getStats().subscribe(stats => {
      this.stats = stats;
    });

    this.apiService.organizations().subscribe(organizations => {
      const orgId = this.apiService.organizationId();
      if (orgId) {
        this.organization = organizations.find((org: Organization) => org.id === orgId) || new Organization();
      }
    });

  }
}
